import { render, staticRenderFns } from "./privacy_list.vue?vue&type=template&id=779e70dc&scoped=true&"
import script from "./privacy_list.vue?vue&type=script&lang=js&"
export * from "./privacy_list.vue?vue&type=script&lang=js&"
import style0 from "./privacy_list.vue?vue&type=style&index=0&id=779e70dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779e70dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VEditDialog,VTextField})
